import { createRouter, createWebHistory } from 'vue-router';
import { VueNavigationClient } from './helpers'
import { auth, initialized, account } from '@/store/authStore'
// import Home from '../views/index.vue';
import store from '../store';
import useFeLocalStorage from "@/composables/useFeLocalStorage.js"
import projects from '@/composables/fe_projects.js'
// import userOperations from '@/composables/userOperations';
// import { detectIdle } from '@/composables/idleDetector';
import auditData from '@/composables/idleAuditData';
const { loadDataPromise, allowedClients } = projects()

const { createAudit } = auditData()
const projectDateStorage = useFeLocalStorage('fe_projectLastActive', "<<NOT FOUND>>")

const HsLocalInfo = useFeLocalStorage('30baab36-b0ca-4e4e-9e33-827d5c9c6096', 
{
    "projectId":null, 
    "clientId":null,
    "projectName":null, 
    "currentUser":null, 
    "SSRSReportPath":null, 
    "SSRSReportPath":null,
    "lcrAccess": null
})

console.log("HsLocalInfo: ", HsLocalInfo.value)

// Vue.use(VueRouter);
// import { createApp } from 'vue';
// const app = createApp();
// app.use(createRouter);


//here, add the idle detection, and create the function for it to call

// let triggered = false //this is for debugging

const fireHeartBeat = () => {    
    //create a new item

    //for debugging
    // if (triggered) {
    //     return
    // }
    
    // triggered = true

    let locationInApp = location.pathname


    if (locationInApp == "") {
        locationInApp = "Dashboard"
    }

    const data = "Idle at: " + locationInApp

    console.log("========== ADDING A NEW AUDIT (IDLE) ==========")

    //send the audit off to be created
    createAudit(HsLocalInfo.value.clientId, data)
        .then(r => {
            console.log("the response: ", r)
        })
        .catch(err => {
            console.log("Error fn fireHeartBeat: create Audit had bad data fed into it: " + err)
        })
}

// detectIdle(fireHeartBeat, (1000 * 60))

//to get the active user, we will get it from the backend - see this article. 
//https://www.c-sharpcorner.com/article/enable-windows-authentication-in-web-api-and-angular-app/

console.log("HAPPEN 6 router/index.js")
store.commit('fe_setProject', HsLocalInfo.value.clientId );
//store.commit('fe_setProject', 1 );

    
const routes = [
    {
        path: '/login',
        name: 'login',
        beforeEnter: async (to, from, next) => {
            // Wrapped in a try/catch to safely handle MSAL failures
            try {
                const result = await auth.login();
                result === false ? next(false) : next();
            } catch (err) {
                next(false);
            }
        },
        meta: { isPublic: true }
    },
    {
        path: '/logouth',
        name: 'logout',
        component: () => import('../views/Home.vue'),
        meta: { isPublic: true }
    },
    {
        path: '/logout',
        name: 'logout',
        beforeEnter: async (to, from, next) => {
            try {
                const result = await auth.logout();
                result === false ? next(false) : next();
            } catch (err) {
                next(false);
            }
        },
        meta: { isPublic: true }
    },
    {
        path: '/pages/check-guid/:guid',
        name: 'checkguid',
        component: () => import('../views/pages/check-guid.vue'),
    },
    //dashboard
    {
        path: '/',
        name: 'home',
        component: () => import('../views/Home.vue'),
       
        meta: { isPublic: true },
    },

    {
        path: '/Default.htm',
        // If a user hits this path inside the SPA, just send them to the root
        redirect: '/' ,
        meta: { isPublic: true },
    },



    //pages
    {
        path: '/pages/faq',
        name: 'faq',
        component: () => import(/* webpackChunkName: "pages-faq" */ '../views/pages/faq.vue'),
        
    },
    {
        path: '/pages/error404',
        name: 'error404',
        component: () => import(/* webpackChunkName: "pages-error404" */ '../views/pages/error404.vue'),
        meta: { layout: 'auth' },
    },
    {
        path: '/pages/error500',
        name: 'error500',
        component: () => import(/* webpackChunkName: "pages-error500" */ '../views/pages/error500.vue'),
        meta: { layout: 'auth' },
    },
    {
        path: '/pages/error503',
        name: 'error503',
        component: () => import(/* webpackChunkName: "pages-error503" */ '../views/pages/error503.vue'),
        meta: { layout: 'auth' },
    },
    {
        path: '/pages/comingsoon',
        name: 'comingsoon',
        component: () => import(/* webpackChunkName: "pages-error503" */ '../views/pages/coming_soon.vue'),
        meta: { layout: 'auth' },
    },
    {
        path: '/customerhub',
        name: 'customerhub',
        component: () => import(/* webpackChunkName: "tables-schedule" */ '../views/feCustomerHub.vue'),
    },
    {
        path: '/site/:clientId/:projectId',
        name: 'siteview',
        component: () => import(/* webpackChunkName: "tables-schedule" */ '../views/feSiteView.vue'),
    },
    {
        path: "/projectlist",
        name: 'projectlist',
        component: () => import(/* webpackChunkName: "tables-schedule" */ '../views/feProjectList.vue'),
        meta: {requiresAdmin: true}
    },
    {
        path: "/clientlist",
        name: 'clientlist',
        component: () => import(/* webpackChunkName: "tables-schedule" */ '../views/feClientList.vue'),
        meta: {requiresAdmin: true}
    },
    {
        path: "/users",
        name: 'users',
        component: () => import(/* webpackChunkName: "tables-schedule" */ '../views/feUserList.vue'),
        meta: {requiresAdmin: true}
 
    }
];

const router = createRouter({
    // mode: 'history',
    history: createWebHistory(),
    linkExactActiveClass: 'active',
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition;
        } else {
            return { top: 0, left: 0 };
        }
    },
});



// ---------------------------------------------------------------------------------------------------------------------
// authentication
// ---------------------------------------------------------------------------------------------------------------------

// hook MSAL into router
const client = new VueNavigationClient(router)

// set up auth and guard routes
router.beforeEach(async (to, from, next) => {
    if (to.meta.isPublic) {
        console.log("is public, no need to auth.")
        return next(); 
    }

    console.log("Checking protected route authentication status. route: ", to.fullPath);
    console.log(`🔒 [Router]: Checking protected route: ${to.fullPath}`);
    console.log(`   └─ Current initialized state:`, initialized.value);



    
  // guarded
  const guarded = true // unguarded.every(path => path !== to.path)
  if (guarded) {
    // initialized
    if (!initialized.value) {
      await auth.initialize(client)
      console.log(`   └─ Initialization complete.`);
    }

    console.log(`👤 [Router]: Current Account:`, account.value);
    // authorised
    if (account.value) {
        console.log(`✅ [Router]: Access GRANTED to ${to.fullPath} for user: ${account.value.username}`);
        return next()
    }

    // unauthorised
    try {
        console.log("⚠️ [Router]: No account found in memory. Launching MSAL Popup...");
        await auth.login()
        console.log(`✅ [Router]: Popup login SUCCESSFUL. Welcome, ${account.value?.username}`);
        return next()
    }
    catch (err) {
        console.error("❌ [Router]: Auth Popup failed or closed by user:", err)
      return next(false)
    }
  }

    next();
});

export default router;
